import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, } from '@fortawesome/free-solid-svg-icons';

function Counter(props: any) {
  let increment = function(): void {
    props.updateFunction( props.value + props.incrementValue );
  }

  let decrement = function(): void {
    props.updateFunction( props.value - props.decrementValue );
  }

  return(
    <div className="counter">
      <FontAwesomeIcon
        onClick={increment}
        icon={faPlusCircle}
        className="App-icon"
      />
      {props.value}
      <FontAwesomeIcon
        onClick={decrement}
        icon={faMinusCircle}
        className="App-icon"
      />
    </div>
  );
}
export default Counter;